const env = process.env.VUE_APP_ENV;

let envApiUrl = '';

if (env === 'production') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_PROD}`;
} else if (env === 'staging') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_STAG}`;
} else if (env === 'stagingV2') {
  envApiUrl = `https://${process.env.VUE_APP_DOMAIN_STAGV2}`;
} else {
  envApiUrl = `http://${process.env.VUE_APP_DOMAIN_DEV}`;
}

export const apiUrl = envApiUrl;
export const appName = process.env.VUE_APP_NAME;
export const appEnv = process.env.VUE_APP_ENV;
export const gitCommitShortSHA = process.env.VUE_APP_GIT_COMMIT_SHORT_SHA;
export const versionTag = process.env.VUE_APP_VERSION_TAG;
